import React from 'react';
import Rete from 'rete';
import Select from 'react-select';
import styled from '@emotion/styled';
import {DefaultSequenceComponent} from "../components";

const StyledContainerDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledSelectWrapperDiv = styled.div`
  width: 100%;
`;

export class NodeSearchControl extends Rete.Control {

    static get DEFAULT_VALUE() {
        return "";
    };

    static component = ({labelText, selectedOption, selectOptions, handleChange, handleFocus}) => {

        return (
            <div>
                <StyledContainerDiv>
                    <StyledSelectWrapperDiv onWheel={(e) => e.stopPropagation()}>
                        <Select
                            value={selectedOption}
                            onChange={handleChange}
                            onFocus={handleFocus}
                            options={selectOptions}
                        />
                    </StyledSelectWrapperDiv>
                </StyledContainerDiv>
            </div>
        )
    };

    constructor(emitter, key, node, readonly = false, labelText) {
        super(key);
        this.emitter = emitter;
        this.key = key;
        this.component = NodeSearchControl.component;

        const initial = node.data[key] || NodeSearchControl.DEFAULT_VALUE;

        node.data[key] = initial;
        this.props = {
            readonly,
            labelText: labelText,
            selectedOption: null,
            selectOptions: [],
            handleChange: selectedOption  => {
                this.props.selectedOption = selectedOption;
                this.putData(this.key, selectedOption.value);
                this.update();
                this.emitter.trigger("process");
            },
            handleFocus: () => {
                this.fetchNodesId(emitter, this.props.selectedOption ?? initial);
            }
        };

        this.fetchNodesId(emitter, initial);

        // refresh 'DefaultSequence' node list if one of it is removed
        this.emitter.on("noderemoved", removedNode => {
            if (this.props.selectedOption === null) {
                return;
            }

            if (this.props.selectedOption.value === removedNode.id) {
                this.props.selectedOption = null;
                this.fetchNodesId(emitter, NodeSearchControl.DEFAULT_VALUE);
            }
        });

        // set 'DefaultSequence' node list if it is loaded from db
        this.emitter.on('dataImported', () => {
            if (initial === NodeSearchControl.DEFAULT_VALUE) {
                return;
            }

            this.fetchNodesId(emitter, initial);
        });
    }

    fetchNodesId(editor, selectedValue) {
        this.props.selectOptions = editor.nodes
            .filter(node => node.name === DefaultSequenceComponent.COMPONENT_NAME)
            .map(node => {
                return {value: node.id, label: node.id}
            });

        if (selectedValue !== NodeSearchControl.DEFAULT_VALUE) {
            let foundSelected = this.props.selectOptions.find(selectOption => selectOption.value === selectedValue);
            if (foundSelected !== undefined) {
                this.props.selectedOption = foundSelected;
            }
        }

        if (typeof this.update === 'function') {
            this.update();
        }
    }
}